<div>
    <app-header></app-header>
    <app-hero></app-hero>
    <app-event-section></app-event-section>
    <app-divider-image [srcbreak]="eventBreak"></app-divider-image>
    <app-info-section></app-info-section>
    <app-divider-image [srcbreak]="contentBreak"></app-divider-image>
    <app-video-section></app-video-section>
    <app-host-section></app-host-section>
    <app-divider-image [srcbreak]="speakerBreak"></app-divider-image>
    <app-full-form></app-full-form>
    <app-firm-info *ngIf="isFirmInfo" [isSinclair]="isSinclair"></app-firm-info>
    <app-footer></app-footer>
</div>